module.exports = __webpack_public_path__ + "static/media/operador-logo-vr.3ebf74be.svg";